<patternlib-button
  (click)="onBackRoute()"
  size="small"
  type="secondary"
>
  <patternlib-icon
    slot="icon"
    icon-name="font-arrow"
    size="24px"
    style="transform: rotate(180deg)"
  ></patternlib-icon>
</patternlib-button>
